import {
    Heading,
    chakra,
    VStack,
    Stack,
    Input,
    Textarea,
    Button,
    Field,
    Text,
} from "@chakra-ui/react";
import {useForm} from "react-hook-form";
import SectionCard from "../components/SectionCard";
import {RiSendPlaneLine} from "react-icons/ri";
import {toaster} from "../components/ui/toaster";
import {post} from 'aws-amplify/api';
import { useRecaptchaV3 } from "../hooks/useRecaptchaV3"; // use the path where you saved it


const ContactPage = () => {
    const {
        register,
        handleSubmit,
        formState: {errors},
        reset
    } = useForm();
    const { execute, ready } = useRecaptchaV3("6LegjgwrAAAAADGv7gO5OZfEYE_DQQP2Jc1DR3np");

    const onSubmit = handleSubmit(async (data) => {
        if (!ready) {
            toaster.create({
                title: "reCAPTCHA not ready",
                description: "Please try again in a moment.",
                type: "error",
            });
            return;
        }

        const token = await execute("contact_form");
        console.log("reCAPTCHA token:", token);

        const formData = { ...data, recaptchaToken: token };
        console.log("Contact form data:", formData);
        const promise = (async () => {
            try {
                const { body } = await post({
                    apiName: "caatContactEmailAPI",
                    path: "/contact",
                    options: { body: formData },
                }).response;

                try {
                    await body.json();
                } catch (jsonErr) {
                    console.warn("Failed to parse JSON:", jsonErr);
                }
                reset();
                return true;
            } catch (err) {
                console.error("API call failed:", err);
                throw err; // rethrow so toaster shows the error toast
            }
        })();

        toaster.promise(promise, {
            loading: {
                title: "Processing...",
                description: "Your message is being processed.",
            },
            success: {
                title: "Message Sent",
                description: "Thank you for your message!",
            },
            error: {
                title: "Error",
                description: "There was an error sending your message.",
            },
        });
    });

    return (
        <SectionCard flexDirection="row" delay={0.1}>
            <chakra.img
                src="./CAAT_Contact_Logo.png"
                alt="Contact Logo"
                maxW="300px"
                mx="auto"
            />

            <VStack flex="1" align="start" spacing={4} w="100%">
                <Heading as="h2" size="lg">
                    Get in Touch
                </Heading>
                <chakra.p fontSize="md">
                    Whether you're curious about a project, have questions, or just want to say hello — feel free to
                    send a message. We'll get back to you as soon as we can.
                </chakra.p>

                <form onSubmit={onSubmit} style={{width: "100%"}}>
                    <Stack gap="4" maxW="lg">
                        <Field.Root required invalid={!!errors.name}>
                            <Field.Label>Name</Field.Label>
                            <Input
                                placeholder="Your name"
                                {...register("name", {required: "Name is required"})}
                            />
                            <Field.ErrorText>{errors.name?.message}</Field.ErrorText>
                        </Field.Root>

                        <Field.Root required invalid={!!errors.email}>
                            <Field.Label>Email</Field.Label>
                            <Input
                                type="email"
                                placeholder="you@example.com"
                                {...register("email", {
                                    required: "Email is required",
                                    pattern: {
                                        value: /\S+@\S+\.\S+/,
                                        message: "Invalid email address",
                                    },
                                })}
                            />
                            <Field.ErrorText>{errors.email?.message}</Field.ErrorText>
                        </Field.Root>

                        <Field.Root required invalid={!!errors.message}>
                            <Field.Label>Message</Field.Label>
                            <Textarea
                                placeholder="Write your message here..."
                                {...register("message", {required: "Message is required"})}
                            />
                            <Field.ErrorText>{errors.message?.message}</Field.ErrorText>
                        </Field.Root>

                        <Button
                            type="submit"
                            bg="brand.green.500"
                            color="white"
                            _hover={{ bg: "brand.green.600" }}
                            alignSelf="start"
                        >
                            <RiSendPlaneLine style={{ marginRight: "0.5rem" }} />
                            Send Message
                        </Button>
                    </Stack>
                </form>
            <Text fontSize="sm" color="gray.600">
                Prefer email?{" "}
                <chakra.a
                    href="mailto:Joerg.Schultz@Tier-Wohl-Team.de"
                    color="brand.green.500"
                    _hover={{ textDecoration: "underline", color: "brand.green.600" }}
                >
                    Joerg.Schultz@Tier-Wohl-Team.de
                </chakra.a>
            </Text>
            </VStack>

        </SectionCard>
    );
};

export default ContactPage;
